import React from "react";
import { DarkModeProvider } from "./DarkModeContext";
import * as Tooltip from "@radix-ui/react-tooltip";
import AppRoutes from "./routing/Routes";
import "./i18n"; // Import i18n configuration
import { CustomToaster } from "utils/toast";
import UpdateReadyCard from "components/UpdateReadyCard";
import SessionExpiredRedirect from "components/SessionExpiredRedirect";

const App = () => {
  return (
    <Tooltip.Provider delayDuration={300}>
      <DarkModeProvider>
        <SessionExpiredRedirect />
        <AppRoutes />
        <CustomToaster />
        <UpdateReadyCard />
      </DarkModeProvider>
    </Tooltip.Provider>
  );
};

export default App;
